import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import SprintStatusGetAllRequest from '../../../projects/sprints/i-services/models/status/SprintStatusGetAllRequest';
import RemoveRequest from '../../../projects/sprints/i-services/models/RemoveRequest';
import SprintStatusSaveRequest from '../../../projects/sprints/i-services/models/status/SprintStatusSaveRequest';
import WsResponseModelT from '../../../schema-builder-server/models/WsResponseModelT';
import SprintStatusResponse from '../../../projects/sprints/i-services/models/status/SprintStatusResponse';

export default class ProjectSprintStatusServices {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	GetAllEvent = new Events<WsResponseModelT<Array<SprintStatusResponse>>>();
	RemoveEvent = new Events<WsResponseModelT<Boolean>>();
	SaveEvent = new Events<WsResponseModelT<Boolean>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('ProjectSprintStatusServices', 'GetAll', 'Main', (res: WsResponseModelT<Array<SprintStatusResponse>>) => {
			self.GetAllEvent.trigger(res);
		});
		webApiService.on('ProjectSprintStatusServices', 'Remove', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.RemoveEvent.trigger(res);
		});
		webApiService.on('ProjectSprintStatusServices', 'Save', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.SaveEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * Получить все статусы проекта
	 */
	async GetAll(query: SprintStatusGetAllRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectSprintStatusServices',
			Method: 'GetAll',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удалить статус спринта
	 */
	async Remove(request: RemoveRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectSprintStatusServices',
			Method: 'Remove',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Добавить или изменить статус проекта
	 */
	async Save(query: SprintStatusSaveRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectSprintStatusServices',
			Method: 'Save',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Получить все статусы проекта
	 */
	async getAllAsync(query: SprintStatusGetAllRequest): Promise<Array<SprintStatusResponse>> {
		return new Promise<Array<SprintStatusResponse>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectSprintStatusServices',
				Method: 'GetAll',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<Array<SprintStatusResponse>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Array<SprintStatusResponse>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удалить статус спринта
	 */
	async removeAsync(request: RemoveRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectSprintStatusServices',
				Method: 'Remove',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Добавить или изменить статус проекта
	 */
	async saveAsync(query: SprintStatusSaveRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectSprintStatusServices',
				Method: 'Save',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}